import styled from 'styled-components';
import { Div, RowDiv, theme } from 'styles';
import { Swiper } from 'swiper/react';

export const SliderWrap = styled(RowDiv)`
  gap: 12px;
  transition: all 150ms ease;

  .prev,
  .next {
    justify-content: center;
    cursor: pointer;
    background-color: ${theme.colors.white33};
    border-radius: 20px;

    &:hover,
    &:active,
    &:focus {
      background-color: ${theme.colors.fill02};
    }
  }

  .prev {
    width: ${({ $current }) => ($current === 0 ? '0' : '40px')};
    min-width: ${({ $current }) => ($current === 0 ? '0' : '40px')};
    overflow: hidden;
  }

  .next {
    width: ${({ $current, $length }) => ($current === $length - 1 ? '0' : '40px')};
    min-width: ${({ $current, $length }) => ($current === $length - 1 ? '0' : '40px')};
    overflow: hidden;
  }
`;

export const CustomSwiper = styled(Swiper)`
  .swiper-button-prev,
  .swiper-button-next {
    display: none;
  }
`;

export const Container = styled(RowDiv)`
  gap: 24px;
`;

export const ImgWrap = styled(Div)`
  border-radius: 24px;
  overflow: hidden;
  min-width: 196px;
  width: 196px;
  height: 196px;
`;

export const ChipText = styled(Div)`
  padding: 6.5px 8px;
  width: fit-content;
  border-radius: 16px;
  background-color: ${theme.colors.primary50};
`;
